import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { MAX_LIVE_CRITERIA_COUNT } from '../constants';

export const LiveAnonUserCriteriaCountQuery = gql`
  query getLiveAnonUserCriteriaCount {
    liveAnonUserCriteriaCount
  }
`;

export const useQueryActiveCriteriaCount = () => {
  const { data, refetch } = useGraphql(LiveAnonUserCriteriaCountQuery, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    count: data?.liveAnonUserCriteriaCount,
    limitReached: data?.liveAnonUserCriteriaCount >= MAX_LIVE_CRITERIA_COUNT,
    refetch,
  };
};
